module.exports = __webpack_public_path__ + "static/media/homestay_china.b42ae8e1.webp";